export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11499.bdc437ef.jpg";